export default "__VITE_ASSET__CkhAaScs__"